import { Component } from '@angular/core';
import { TranslationService } from '../app.translation-service';

@Component({
	selector: 'app-right-menu',
	templateUrl: './right-menu.component.html',
	styleUrls: ['./right-menu.component.less']
})
export class RightMenuComponent {
	constructor(public i18n: TranslationService){
	}
}
